import { render, staticRenderFns } from "./ViewPayout.vue?vue&type=template&id=45247c47"
import script from "./ViewPayout.vue?vue&type=script&lang=js"
export * from "./ViewPayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports